import React from 'react';

/**
 * Reusable testimonial block.
 */
const Testimonial = ({ quote, name, role, avatarColor }) => {
  return (
    <div className="testimonial">
      <div className="testimonial__quote">{quote}</div>
      <div className="testimonial__author">
        <div className="testimonial__avatar" style={{ background: avatarColor }}></div>
        <div style={{ textAlign: 'left' }}>
          <div className="testimonial__name">{name}</div>
          <div className="testimonial__role">{role}</div>
        </div>
      </div>
    </div>
  );
};

export default Testimonial;
